// Keep in sync with `export_data_catalog_dataset_step_shapes.py`
export enum ExportDataCatalogDatasetVariableName {
  DATASET_NAME = 'datasetName',
  FOLDER_ID = 'folderId',
}

// Keep in sync with `send_to_document.yaml`
export enum SendToDocumentVariableName {
  DOCUMENT_ID = 'documentId',
}
